import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(LanguageFr);

    /** @ngInject */
    function LanguageFr($translateProvider) {
        $translateProvider.translations('fr',
            // TRANSLATIONS
        );
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/languages/fr.ts